<!-- Filter drawer -->
<p-drawer [(visible)]="filterSidebar" position="right">
    <ng-template pTemplate>
        <div *ngFor="let col of filters" class="p-grid p-mb-3">
            <div class="p-col-12 p-mb-1">
                <label>{{ col.header }}</label>
            </div>
            <div class="p-col-12">
                <input *ngIf="col.type === 'string' || col.type === 'number'"
                    [type]="col.type === 'number' ? 'number' : 'text'" pInputText [style]="{ width: '100%' }"
                    [(ngModel)]="localFilters[col.field]" [placeholder]="col.header" />

                <input *ngIf="col.type === 'date'" type="date" pInputText [style]="{ width: '100%' }"
                    [(ngModel)]="localFilters[col.field]" />

                <p-select *ngIf="col.type === 'select'" [options]="col.options" [(ngModel)]="localFilters[col.field]"
                    optionLabel="label" optionValue="value" [placeholder]="col.header" [showClear]="true"
                    [style]="{ width: '100%' }" />
            </div>
        </div>

        <div class="p-field p-grid">
            <div class="p-col-6">
                <button pButton type="reset" class="p-button p-button-options btn-block" label="annulla"
                    (click)="resetFilters()"></button>
            </div>
            <div class="p-col-6">
                <button pButton type="submit" class="p-button p-button-primary btn-block" label="cerca"
                    (click)="applyFilters()"></button>
            </div>
        </div>
    </ng-template>
</p-drawer>

<!-- Header -->
<div class="top-main-wrapper">
    <div class="dash-header">
        <div class="dash-title">
            <div class="p-field p-grid">
                <div class="p-col-6 p-md-6">
                    <h3>{{ title }}</h3>
                </div>
                <div class="p-col-6 p-md-6">
                    <button *ngIf="filters?.length" type="text" pButton label="Filter" icon="pi pi-filter"
                        class="p-button p-button-options p-mr-2 pull-right" (click)="filterSidebar = true"></button>

                    <button *ngIf="createLink" pButton pRipple icon="pi pi-plus" [routerLink]="createLink"
                        [label]="createLabel" class="p-button p-button-primary p-mr-2 pull-right"></button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="main-inner">
    <div class="p-fluid">
        <div class="p-field p-grid list">
            <div class="p-col-12 p-md-12">

                <!-- Active filter tags + count -->
                <div class="filter-options">
                    <div class="p-field p-grid">
                        <div class="p-col-12 p-md-8">
                            <div class="item-size pull-left">
                                <span class="filter-tag" *ngFor="let col of activeFilters">
                                    {{ col.header }} <strong>{{ filterLabel(col) }}</strong>
                                    <span class="close">
                                        <i class="pi pi-times" (click)="clearFilter(col.field)"></i>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="p-col-12 p-md-4">
                            <span class="count-item pull-right">{{ totalCount }} Items</span>
                        </div>
                    </div>
                </div>

                <!-- Register ngx-pagination metadata for server-side paging -->
                <div
                    *ngFor="let row of items | paginate: { id: paginationId, itemsPerPage: pageSize, currentPage: page, totalItems: totalCount }">
                </div>

                <!-- Loading -->
                <div *ngIf="loading" class="p-text-center p-p-4">
                    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                    <p class="p-mt-2">Caricamento…</p>
                </div>

                <!-- Empty state -->
                <div *ngIf="!loading && items?.length === 0" class="p-text-center p-p-6">
                    <i class="pi pi-inbox" style="font-size: 2.5rem; opacity: .4"></i>
                    <p class="p-mt-2">Nessun elemento trovato</p>
                </div>

                <p-table *ngIf="!loading && items?.length" [columns]="columns" [value]="items" [paginator]="false">
                    <ng-template pTemplate="header">
                        <tr>
                            <th *ngFor="let col of columns" [style.width]="col.width"
                                [style.text-align]="col.align || 'left'">
                                {{ col.header }}
                            </th>
                            <th></th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td *ngFor="let col of columns" [style.text-align]="col.align || 'left'"
                                [ngSwitch]="col.type || 'text'">

                                <!-- link -->
                                <a *ngSwitchCase="'link'" [routerLink]="col.link ? col.link(row) : null">
                                    {{ cellValue(col, row) }}
                                </a>

                                <!-- tag / boolean -->
                                <p-tag *ngSwitchCase="'tag'" [severity]="tagFor(col, row)?.severity"
                                    [value]="tagFor(col, row)?.label"></p-tag>
                                <p-tag *ngSwitchCase="'boolean'" [severity]="tagFor(col, row)?.severity"
                                    [value]="tagFor(col, row)?.label"></p-tag>

                                <!-- date -->
                                <span *ngSwitchCase="'date'">
                                    {{ cellValue(col, row) | date: (col.dateFormat || 'mediumDate') }}
                                </span>

                                <!-- image -->
                                <img *ngSwitchCase="'image'" [src]="col.image ? col.image(row) : cellValue(col, row)"
                                    alt="" class="table-thumb"
                                    style="width: 42px; height: 42px; object-fit: cover; border-radius: 6px" />

                                <!-- rating -->
                                <p-rating *ngSwitchCase="'rating'" [ngModel]="cellValue(col, row)"
                                    [readonly]="true"></p-rating>

                                <!-- custom template -->
                                <ng-container *ngSwitchCase="'custom'" [ngTemplateOutlet]="col.template"
                                    [ngTemplateOutletContext]="{ $implicit: row, col: col }"></ng-container>

                                <!-- text (default) -->
                                <span *ngSwitchDefault>{{ cellValue(col, row) }}</span>
                            </td>

                            <td class="action">
                                <button *ngIf="deletable" pButton pRipple label="delete" icon="pi pi-trash"
                                    class="p-button p-button-danger p-button-outline pull-right p-mr-2"
                                    (click)="onDelete(row)"></button>

                                <button *ngIf="editLink" pButton pRipple [label]="editLabel" icon="pi pi-pencil"
                                    class="p-button p-button-primary pull-right p-mr-2"
                                    [routerLink]="editLink(row)"></button>

                                <ng-container *ngFor="let a of rowActions">
                                    <button *ngIf="!a.visible || a.visible(row)" pButton pRipple [label]="a.label"
                                        [icon]="a.icon" [pTooltip]="a.tooltip"
                                        [class]="'pull-right p-mr-2 ' + (a.styleClass || 'p-button p-button-options')"
                                        [routerLink]="a.link ? a.link(row) : null"
                                        (click)="!a.link && onRowAction(a, row)"></button>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <!-- Pagination footer -->
                <div class="p-grid" *ngIf="!loading && items?.length">
                    <div class="p-col-12 p-md-4">
                        <p class="p-pt-1">
                            <span class="count-item pull-left">{{ rangeStart }} - {{ rangeEnd }} di {{ totalCount }}
                                risultati ({{ shownCount }} mostrati)</span>
                        </p>
                    </div>
                    <div class="p-col-12 p-md-8">
                        <pagination-controls [id]="paginationId" previousLabel="Prev" nextLabel="Next" responsive="true"
                            (pageChange)="onPageChange($event)">
                        </pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-confirmDialog [style]="{ width: '50vw' }" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" #cd>
    <p-footer>
        <button type="button" pButton icon="fa fa-close" class="p-button p-button-danger p-mr-2" label="No"
            (click)="cd.reject()"></button>
        <button type="button" pButton icon="fa fa-check" class="p-button p-button-success p-mr-2" label="Si"
            (click)="cd.accept()"></button>
    </p-footer>
</p-confirmDialog>